import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const StarHalf = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='StarHalf' {...props}>
    <g fill='none' fillRule='evenodd'><polygon fill='#000' fillOpacity='.2' points='12 16.667 12 2 14.5 9.5 22 9.5 16 14 19 22' /><polygon fill='#FFC95E' points='12 16.667 5 22 8 14 2 9.5 9.5 9.5 12 2' /></g>
  </StyledIcon>
);
